import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TextField, IconButton } from '@totalsoft/rocket-ui';

const ApprovalTypeDecisionReasonsListItemComponent = ({ reason, index, dispatch }) => {
  const { t } = useTranslation();
  const onReasonChanged = (index, value) => {
    dispatch({ type: 'OnReasonChanged', index, value });
  };

  const onDeleteReason = index => {
    dispatch({ type: 'OnDeleteReason', index });
  };

  return (
    <TableRow>
      <TableCell>
        <TextField
          fullWidth
          onChange={event => onReasonChanged(index, event)}
          value={reason.reason}
          label={t('ApprovalTypes.ApprovalTypeDecisionReasons.Reason')}
        />
      </TableCell>
      <TableCell align='right'>
        <IconButton
          type='delete'
          fontSize='medium'
          color='transparent'
          tooltip={t('Tooltips.Delete')}
          onClick={() => onDeleteReason(index)}
        />
      </TableCell>
    </TableRow>
  );
};

ApprovalTypeDecisionReasonsListItemComponent.propTypes = {
  reason: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired
};

export default ApprovalTypeDecisionReasonsListItemComponent;
